import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
  __name: 'Carousel',
  props: {
    pagination: Object,
    // pagination
    autoplayCarousel: [Object, Boolean],
    // autoplay carousel
    // carousel module
    modulesCarousel: {
      type: Array,
      default: () => []
    },
    // swipe slide image data
    slideData: {
      type: Array,
      required: true,
      default: () => []
    },
    // is observer
    isObserver: {
      type: Boolean,
      default: true
    },
    // is Carousel loop
    isCarouselLoop: {
      type: Boolean,
      default: false
    }
  },
  emits: ['touchStart', 'touchMove', 'touchEnd', 'changeSlide'],
  setup(__props, {
    expose: __expose,
    emit: emits
  }) {
    var swiperRef = ref(null);
    var onTouchStart = el => emits('touchStart', el);
    var onTouchEnd = el => emits('touchEnd', el);
    var onTouchMove = (el, event) => emits('touchMove', el, event);
    var onSlideChange = el => emits('changeSlide', el);
    var onCarouselSildeTo = (index, speed = 0) => swiperRef.value.slideTo(index, speed);
    var onSwiper = swiper => {
      swiperRef.value = swiper;
    };

    // expose method，Used for parent component calls
    __expose({
      onCarouselSildeTo
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Swiper), {
        modules: __props.modulesCarousel,
        observer: __props.isObserver,
        pagination: __props.pagination,
        loop: __props.isCarouselLoop,
        autoplay: __props.autoplayCarousel,
        onSwiper: onSwiper,
        onSlideChange: onSlideChange,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slideData, (slide, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "content", {
              slide: slide,
              index: index
            })]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 3
      }, 8, ["modules", "observer", "pagination", "loop", "autoplay"]);
    };
  }
};